// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var MappingType_Enum;
(function (MappingType_Enum) {
    MappingType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    MappingType_Enum["APPOINTMENT"] = "APPOINTMENT";
    MappingType_Enum["WRITEBACK"] = "WRITEBACK";
    MappingType_Enum["RECALL"] = "RECALL";
})(MappingType_Enum || (MappingType_Enum = {}));
export var MappingType_Enum_index;
(function (MappingType_Enum_index) {
    MappingType_Enum_index[MappingType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    MappingType_Enum_index[MappingType_Enum_index["APPOINTMENT"] = 1] = "APPOINTMENT";
    MappingType_Enum_index[MappingType_Enum_index["WRITEBACK"] = 2] = "WRITEBACK";
    MappingType_Enum_index[MappingType_Enum_index["RECALL"] = 3] = "RECALL";
})(MappingType_Enum_index || (MappingType_Enum_index = {}));
export const MappingsService = {
    // ListMappings reads location settings for appointment status, recall type, or writeback status mappings for all sources for a location.
    // example response for appointment:
    // {
    // "mappings": [
    // {
    // "sourceID": "cd2dbe9e-3fde-4138-9978-10fe14752dce",
    // "externalValues": [
    // {"label": "Canceled", "value": "CA"},
    // {"label": "Canceled", "value": "DE"},
    // {"label": "Confirmed", "value": "Confirmed"},
    // {"label": "No Show", "value": "NS"},
    // {"label": "Unconfirmed", "value": ""}
    // ],
    // "mapping": {
    // "Attempted": [],
    // "Canceled": [
    // {"label": "Canceled", "value": "CA"},
    // {"label": "Canceled", "value": "DE"},
    // ],
    // "Completed": [],
    // "Confirmed": [
    // {"label": "Confirmed", "value": "Confirmed"},
    // ],
    // "In Office": [],
    // "Unconfirmed": [
    // {"label": "Unconfirmed", "value": ""}
    // ]
    // }
    // },
    // ]
    // }
    ListMappings(fn, req) {
        return fn(`/syncapp/mappings/v1/mappings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // UpsertMappings persists selections made in the frontend for appointment status, recall type, or writeback status mappings to the correct location setting.
    // appointment -> appointment_status_map
    // writeback -> writeback_status_map
    // recall -> recall_types_to_use
    UpsertMappings(fn, req) {
        return fn(`/syncapp/mappings/v1/mappings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
